export const API_URL = process.env.REACT_APP_API_URL
export const API_SECRET = process.env.REACT_APP_API_SECRET
export const LANDING_URL = process.env.REACT_APP_LANDING_URL
export const PREMIUM_NO_ACCESS = process.env.REACT_APP_PREMIUM === '0'
export const ICON_DOMAIN = process.env.REACT_APP_ICON_DOMAIN
